import {
  generateSkinDefaults,
  backgroundSkinParams,
  borderSkinParams,
  cornerSkinParams,
  boxShadowSkinParams,
  withDefaultValues,
} from '@wix/editor-elements-panel';
import type { SkinDefinition } from '@wix/editor-elements-panel/dist/adapters/types';

const skinParams = {
  ...backgroundSkinParams,
  ...borderSkinParams,
  ...cornerSkinParams,
  ...boxShadowSkinParams,
};

export const skinParamsWithDefaults = withDefaultValues(skinParams);

export const SelectableContainerSkinDefinition: Record<string, SkinDefinition> =
  {
    'wixui.skins.SelectableContainer': skinParamsWithDefaults,
  };

export default generateSkinDefaults(SelectableContainerSkinDefinition);
